
export const initializeAudioContext = async (): Promise<AudioContext | null> => {
  try {
    const context = new (window.AudioContext || (window as any).webkitAudioContext)();
    
    if (context.state === 'suspended') {
      await context.resume();
    }
    
    return context;
  } catch (error) {
    console.log('Audio context initialization failed:', error);
    return null;
  }
};

export const playSoftSuccessSound = async (
  audioContextRef: React.MutableRefObject<AudioContext | null>,
  soundEnabled: boolean
) => {
  if (!soundEnabled || !audioContextRef.current) return;
  
  try {
    if (!audioContextRef.current) return;
    
    const ctx = audioContextRef.current;
    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();
    
    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);
    
    const now = ctx.currentTime;
    oscillator.frequency.setValueAtTime(400, now);
    oscillator.type = 'triangle';
    
    gainNode.gain.setValueAtTime(0, now);
    gainNode.gain.linearRampToValueAtTime(0.1, now + 0.01);
    gainNode.gain.exponentialRampToValueAtTime(0.001, now + 0.5);
    
    oscillator.start(now);
    oscillator.stop(now + 0.5);
    
  } catch (error) {
    console.log('Could not play success sound:', error);
  }
};

export const closeAudioContext = async (
  audioContextRef: React.MutableRefObject<AudioContext | null>
) => {
  if (audioContextRef.current && audioContextRef.current.state !== 'closed') {
    try {
      await audioContextRef.current.close();
    } catch (e) {
      console.warn('Error closing audio context:', e);
    }
    audioContextRef.current = null;
  }
};
